import ImagePreloader from 'image-preloader'

import log from 'salvo-lite/log'

class Preloader {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
        this._elems = elem.querySelectorAll('[data-preload]:not([data-preload="loaded"])')
        this._preloader = new ImagePreloader()
        this._preloads = []
        this._widths = [
            769,
            768,
            480
        ]
        this._evt = new Event('preload-complete')
    }

    onInit () {
        this._theLogic()
        this._preloadLoop()

        document.addEventListener('preload-update', e => {
            this._elems = this._elem.querySelectorAll('[data-preload]:not([data-preload="loaded"])')
            this._theLogic()
            this._preloadLoop()
        })
        log.debug(this._name, 'Initiated', this)
    }

    _preloadLoop () {
        this._preloads.forEach(obj => {
            if (obj.resize) {
                let widths = []
                for (let key in obj.resize) {
                    widths.push(key)
                }
                let relWidth = this._getRelWidth(widths)
                console.log(`GOT WIDTH ${relWidth}`)
                this._preload(obj, relWidth)
            } else {
                this._preload(obj)
            }
        })
    }

    _preload (obj, width) {
        let objToLoad = obj.resize && obj.resize[width] ? obj.resize[width] : obj
        console.log('loading')
        console.log(objToLoad)
        this._preloader.preload(objToLoad.src).then(data => this._onComplete(data, objToLoad))
    }

    _getRelWidth (widths) {
        let relWidth = false
        let sWidth = screen.width

        if (sWidth >= widths[widths.length - 1]) {
            relWidth = widths[widths.length - 1]
        } else {
            for (let width of widths) {
                if (sWidth <= width) {
                    relWidth = width
                    break
                }
            }
        }

        return `${relWidth}`
    }

    _theLogic () {
        this._elems.forEach(elem => {
            let data = elem.getAttribute('data-preload')

            let obj = {
                'elem': elem,
                'src': data,
                'json': data.includes('{') ? JSON.parse(data) : null
            }

            if (obj.json) {
                obj.resize = {}

                for (let key in obj.json) {
                    obj.resize[key] = {}
                    obj.resize[key].src = obj.json[key]
                    obj.resize[key].loaded = false
                    obj.resize[key].elem = elem
                }
            }

            console.log(obj)

            this._preloads.push(obj)
        })
    }

    _onComplete (data, obj) {
        let imgSrc = data[0].value.src

        if (obj.elem.nodeName === 'SOURCE') {
            obj.elem.setAttribute('srcset', imgSrc)
        } else if (obj.elem.nodeName === 'IMG') {
            obj.elem.src = imgSrc
        } else {
            obj.elem.style.backgroundImage = `url(${imgSrc})`
        }

        obj.loaded = true
        obj.elem.setAttribute('data-preload', 'loaded')
        obj.elem.dispatchEvent(this._evt)
    }
}

export default Preloader



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Preload.js